export class AppConfig {
    baseUrl: string;
}